const createParamsSerializer = () => ({
    serialize: (params: any) => {
        const searchParams = new URLSearchParams();

        const addParams = (obj: any, prefix = '') => {
            for (const key in obj) {
                const value = obj[key];
                const paramKey = prefix ? `${prefix}.${key}` : key;

                if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
                    addParams(value, paramKey);
                } else {
                    if (Array.isArray(value)) {
                        value.forEach(item => searchParams.append(paramKey, item));
                    } else {
                        searchParams.append(paramKey, value);
                    }
                }
            }
        };

        addParams(params);
        return searchParams.toString();
    }
});

export default createParamsSerializer;

